import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function create_area(params: Record<string, any>) {
  return request.post('/mjstore/create_area', params);
}

export async function update_area(params: Record<string, any>) {
  return request.post('/mjstore/update_area', params);
}

export async function delete_area(params: Record<string, any>) {
  return request.post('/mjstore/delete_area', params);
}

export async function recover_area(params: Record<string, any>) {
  return request.post('/mjstore/recover_area', params);
}

export async function get_set_record_item_detail(params: Record<string, any>) {
  return request.post('/mjstore/get_set_record_item_detail', params);
}

export async function query_area_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_area_list', params);
}

export async function analyse_day_appointment(params: Record<string, any>) {
  return request.post('/mjstore/analyse_day_appointment', params);
}

export async function analyse_month_appointment(params: Record<string, any>) {
  return request.post('/mjstore/analyse_month_appointment', params);
}

export async function query_order_record_order_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  const res: PageResult = await request.post('/mjstore/query_order_record_order_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}

export async function query_customer_shop_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_customer_shop_change_record_list', params);
}

export async function query_staff_select_current_shop_first_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_staff_select_current_shop_first_list', params);
}

let all_staff_list: any = null;
export async function query_staff_select_current_shop_first_list2(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  if (all_staff_list == null) {
    return new Promise(resolve => {
      request
        .post('/mjstore/query_staff_select_current_shop_first_list', params)
        .then(function (res: any) {
          all_staff_list = res;
          resolve(res);
        });
    });
  } else {
    return new Promise(resolve => {
      if (params?.shop_id) {
        const shop_staff_list = all_staff_list.data.filter((item: any) => {
          if (item.shop_id == params.shop_id) {
            return true;
          }
          return false;
        });
        all_staff_list.data.map((item: any) => {
          if (item.shop_id != params.shop_id) {
            shop_staff_list.push(item);
          }
        });
        all_staff_list.data = shop_staff_list;
        // all_staff_list.data.concat(no_shop_staff_list);
        resolve(all_staff_list);
      } else {
        resolve(all_staff_list);
      }
    });
  }
}

export async function create_customer(params: Record<string, any>) {
  return request.post('/mjstore/create_customer', params);
}

export async function update_customer(params: Record<string, any>) {
  return request.post('/mjstore/update_customer', params);
}

export async function delete_customer(params: Record<string, any>) {
  return request.post('/mjstore/delete_customer', params);
}

export async function recover_customer(params: Record<string, any>) {
  return request.post('/mjstore/recover_customer', params);
}

export async function query_customer_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_customer_list', params);
}

export async function create_c_z_record(params: Record<string, any>) {
  return request.post('/mjstore/create_c_z_record', params);
}

export async function update_c_z_record(params: Record<string, any>) {
  return request.post('/mjstore/update_c_z_record', params);
}

export async function delete_c_z_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_c_z_record', params);
}

export async function recover_c_z_record(params: Record<string, any>) {
  return request.post('/mjstore/recover_c_z_record', params);
}

export async function query_c_z_record_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_c_z_record_list', params);
}

export async function create_g_k(params: Record<string, any>) {
  return request.post('/mjstore/create_g_k', params);
}

export async function update_g_k(params: Record<string, any>) {
  return request.post('/mjstore/update_g_k', params);
}

export async function delete_g_k(params: Record<string, any>) {
  return request.post('/mjstore/delete_g_k', params);
}

export async function recover_g_k(params: Record<string, any>) {
  return request.post('/mjstore/recover_g_k', params);
}

export async function query_g_k_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_g_k_list', params);
}

export async function create_grade(params: Record<string, any>) {
  return request.post('/mjstore/create_grade', params);
}

export async function update_grade(params: Record<string, any>) {
  return request.post('/mjstore/update_grade', params);
}

export async function delete_grade(params: Record<string, any>) {
  return request.post('/mjstore/delete_grade', params);
}

export async function recover_grade(params: Record<string, any>) {
  return request.post('/mjstore/recover_grade', params);
}

export async function query_grade_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_grade_list', params);
}

export async function query_grade_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_grade_change_record_list', params);
}

export async function create_policy(params: Record<string, any>) {
  return request.post('/mjstore/create_policy', params);
}

export async function update_policy(params: Record<string, any>) {
  return request.post('/mjstore/update_policy', params);
}

export async function delete_policy(params: Record<string, any>) {
  return request.post('/mjstore/delete_policy', params);
}

export async function recover_policy(params: Record<string, any>) {
  return request.post('/mjstore/recover_policy', params);
}

export async function query_policy_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_policy_list', params);
}

export async function create_project(params: Record<string, any>) {
  return request.post('/mjstore/create_project', params);
}

export async function update_project(params: Record<string, any>) {
  return request.post('/mjstore/update_project', params);
}

export async function delete_project(params: Record<string, any>) {
  return request.post('/mjstore/delete_project', params);
}

export async function recover_project(params: Record<string, any>) {
  return request.post('/mjstore/recover_project', params);
}

export async function query_project_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_project_list', params);
}

export async function create_project_type(params: Record<string, any>) {
  return request.post('/mjstore/create_project_type', params);
}

export async function update_project_type(params: Record<string, any>) {
  return request.post('/mjstore/update_project_type', params);
}

export async function delete_project_type(params: Record<string, any>) {
  return request.post('/mjstore/delete_project_type', params);
}

export async function recover_project_type(params: Record<string, any>) {
  return request.post('/mjstore/recover_project_type', params);
}

export async function query_project_type_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_project_type_list', params);
}

export async function create_shop(params: Record<string, any>) {
  return request.post('/mjstore/create_shop', params);
}

export async function update_shop(params: Record<string, any>) {
  return request.post('/mjstore/update_shop', params);
}

export async function delete_shop(params: Record<string, any>) {
  return request.post('/mjstore/delete_shop', params);
}

export async function recover_shop(params: Record<string, any>) {
  return request.post('/mjstore/recover_shop', params);
}

export async function query_shop_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_shop_list', params);
}

export async function query_shop_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_shop_type_list', params);
}
export async function create_shop_type(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/create_shop_type', params);
}
export async function update_shop_type(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/update_shop_type', params);
}

export async function create_sk_type(params: Record<string, any>) {
  return request.post('/mjstore/create_sk_type', params);
}

export async function update_sk_type(params: Record<string, any>) {
  return request.post('/mjstore/update_sk_type', params);
}

export async function delete_sk_type(params: Record<string, any>) {
  return request.post('/mjstore/delete_sk_type', params);
}

export async function recover_sk_type(params: Record<string, any>) {
  return request.post('/mjstore/recover_sk_type', params);
}

export async function query_sk_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_sk_type_list', params);
}

export async function create_staff(params: Record<string, any>) {
  return request.post('/mjstore/create_staff', params);
}

export async function update_staff(params: Record<string, any>) {
  return request.post('/mjstore/update_staff', params);
}

export async function delete_staff(params: Record<string, any>) {
  return request.post('/mjstore/delete_staff', params);
}

export async function recover_staff(params: Record<string, any>) {
  return request.post('/mjstore/recover_staff', params);
}

export async function query_staff_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_staff_list', params);
}
export async function query_staff_serve_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_staff_serve_record_list', params);
}

export async function query_staff_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_staff_select_list', params);
}

export async function query_order_record_normal_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_order_record_normal_list ', params);
}

export async function query_order_record_card_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  const res: PageResult = await request.post('/mjstore/query_order_record_card_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: any) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}

export async function create_x_d(params: Record<string, any>) {
  return request.post('/mjstore/create_x_d', params);
}

export async function update_x_d(params: Record<string, any>) {
  return request.post('/mjstore/update_x_d', params);
}

export async function delete_x_d(params: Record<string, any>) {
  return request.post('/mjstore/delete_x_d', params);
}

export async function recover_x_d(params: Record<string, any>) {
  return request.post('/mjstore/recover_x_d', params);
}

export async function get_project_by_id(params: Record<string, any>) {
  return request.post('/mjstore/get_project_by_id', params);
}

export async function query_x_d_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_x_d_list', params);
}

export async function create_card(params: Record<string, any>) {
  return request.post('/mjstore/create_card', params);
}

export async function update_card(params: Record<string, any>) {
  return request.post('/mjstore/update_card', params);
}

export async function delete_card(params: Record<string, any>) {
  return request.post('/mjstore/delete_card', params);
}

export async function recover_card(params: Record<string, any>) {
  return request.post('/mjstore/recover_card', params);
}

export async function query_card_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_card_list', params);
}

export async function query_card_price_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_card_price_change_record_list', params);
}

export async function create_card_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/create_card_price_change_record', params);
}

export async function update_card_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/update_card_price_change_record', params);
}

export async function delete_card_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_card_price_change_record', params);
}

export async function create_card_project(params: Record<string, any>) {
  return request.post('/mjstore/create_card_project', params);
}

export async function update_card_project(params: Record<string, any>) {
  return request.post('/mjstore/update_card_project', params);
}

export async function delete_card_project(params: Record<string, any>) {
  return request.post('/mjstore/delete_card_project', params);
}

export async function recover_card_project(params: Record<string, any>) {
  return request.post('/mjstore/recover_card_project', params);
}

export async function query_card_project_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_card_project_list', params);
}

export async function create_card_record(params: Record<string, any>) {
  return request.post('/mjstore/create_card_record', params);
}

export async function query_card_record_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_card_record_list', params);
}

export async function create_card_remove(params: Record<string, any>) {
  return request.post('/mjstore/create_card_remove', params);
}

export async function query_card_remove_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_card_remove_list', params);
}

export async function query_customer_wallet_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_customer_wallet_list', params);
}

export async function create_hk_type(params: Record<string, any>) {
  return request.post('/mjstore/create_hk_type', params);
}

export async function update_hk_type(params: Record<string, any>) {
  return request.post('/mjstore/update_hk_type', params);
}

export async function delete_hk_type(params: Record<string, any>) {
  return request.post('/mjstore/delete_hk_type', params);
}

export async function recover_hk_type(params: Record<string, any>) {
  return request.post('/mjstore/recover_hk_type', params);
}

export async function query_hk_type_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_hk_type_list', params);
}

export async function create_order_record(params: Record<string, any>) {
  return request.post('/mjstore/create_order_record', params);
}

export async function query_order_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_order_record_list', params);
}

export async function create_order_remove(params: Record<string, any>) {
  return request.post('/mjstore/create_order_remove', params);
}

export async function query_order_remove_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_order_remove_list', params);
}

export async function create_order_used_record(params: Record<string, any>) {
  return request.post('/mjstore/create_order_used_record', params);
}

export async function query_order_used_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_order_used_record_list', params);
}

export async function query_project_price_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_project_price_change_record_list', params);
}

export async function create_project_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/create_project_price_change_record', params);
}

export async function update_project_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/update_project_price_change_record', params);
}

export async function delete_project_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_project_price_change_record', params);
}

export async function create_project_set(params: Record<string, any>) {
  return request.post('/mjstore/create_project_set', params);
}

export async function update_project_set(params: Record<string, any>) {
  return request.post('/mjstore/update_project_set', params);
}

export async function delete_project_set(params: Record<string, any>) {
  return request.post('/mjstore/delete_project_set', params);
}

export async function recover_project_set(params: Record<string, any>) {
  return request.post('/mjstore/recover_project_set', params);
}

export async function query_project_set_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_project_set_list', params);
}

export async function query_project_set_card_item_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_project_set_card_item_list', params);
}

export async function query_project_set_item_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_project_set_item_list', params);
}

export async function query_set_price_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_set_price_change_record_list', params);
}

export async function create_set_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/create_set_price_change_record', params);
}
export async function delete_set_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_set_price_change_record', params);
}
export async function update_set_price_change_record(params: Record<string, any>) {
  return request.post('/mjstore/update_set_price_change_record', params);
}
export async function create_set_record(params: Record<string, any>) {
  return request.post('/mjstore/create_set_record', params);
}

export async function query_set_record_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_set_record_list', params);
}

export async function create_bed(params: Record<string, any>) {
  return request.post('/mjstore/create_bed', params);
}

export async function update_bed(params: Record<string, any>) {
  return request.post('/mjstore/update_bed', params);
}

export async function update_bed_status(params: Record<string, any>) {
  return request.post('/mjstore/update_bed_status', params);
}

export async function delete_bed(params: Record<string, any>) {
  return request.post('/mjstore/delete_bed', params);
}

export async function recover_bed(params: Record<string, any>) {
  return request.post('/mjstore/recover_bed', params);
}

export async function query_bed_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_bed_list', params);
}

export async function query_bed_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_bed_change_record_list', params);
}

export async function delete_order_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_order_record', params);
}

export async function delete_order_remove(params: Record<string, any>) {
  return request.post('/mjstore/delete_order_remove', params);
}

export async function create_order_used_record_by_card(params: Record<string, any>) {
  return request.post('/mjstore/create_order_used_record_by_card', params);
}

export async function delete_order_used_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_order_used_record', params);
}

export async function delete_card_remove(params: Record<string, any>) {
  return request.post('/mjstore/delete_card_remove', params);
}
export async function get_project_set_item_detail(params: Record<string, any>) {
  return request.post('/mjstore/get_project_set_item_detail', params);
}
export async function delete_card_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_card_record', params);
}

export async function get_card_by_id(params: Record<string, any>) {
  return request.post('/mjstore/get_card_by_id', params);
}

export async function active_card_record(params: Record<string, any>) {
  return request.post('/mjstore/active_card_record', params);
}
export async function delete_order_used_cancel_record(params: Record<string, any>) {
  return request.post('/mjstore/delete_order_used_cancel_record', params);
}
export async function query_order_used_cancel_record_list(params: Record<string, any>) {
  return request.post('/mjstore/query_order_used_cancel_record_list', params);
}
export async function create_order_used_cancel_record(params: Record<string, any>) {
  return request.post('/mjstore/create_order_used_cancel_record', params);
}
export async function get_customer_detail(params: Record<string, any>) {
  return request.post('/mjstore/get_customer_detail', params);
}
export async function query_customer_base_info_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_customer_base_info_list', params);
}
export async function query_require_info_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_require_info_list', params);
}
export async function query_post_sale_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_post_sale_list', params);
}
export async function query_service_detail_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_service_detail_list', params);
}
export async function query_appointment_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_appointment_list', params);
}
export async function query_plan_info_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_plan_info_list', params);
}
export async function query_feedback_info_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_feedback_info_list', params);
}
export async function update_customer_base_info(params: Record<string, any>) {
  return request.post('/mjstore/update_customer_base_info', params);
}
export async function create_feedback_info(params: Record<string, any>) {
  return request.post('/mjstore/create_feedback_info', params);
}
export async function update_feedback_info(params: Record<string, any>) {
  return request.post('/mjstore/update_feedback_info', params);
}
export async function create_customer_base_info(params: Record<string, any>) {
  return request.post('/mjstore/create_customer_base_info', params);
}
export async function create_require_info(params: Record<string, any>) {
  return request.post('/mjstore/create_require_info', params);
}
export async function create_plan_info(params: Record<string, any>) {
  return request.post('/mjstore/create_plan_info', params);
}
export async function update_plan_info(params: Record<string, any>) {
  return request.post('/mjstore/update_plan_info', params);
}
export async function update_post_sale(params: Record<string, any>) {
  return request.post('/mjstore/update_post_sale', params);
}
export async function create_post_sale(params: Record<string, any>) {
  return request.post('/mjstore/create_post_sale', params);
}
export async function update_require_info(params: Record<string, any>) {
  return request.post('/mjstore/update_require_info', params);
}
export async function create_service_detail(params: Record<string, any>) {
  return request.post('/mjstore/create_service_detail', params);
}
export async function update_service_detail(params: Record<string, any>) {
  return request.post('/mjstore/update_service_detail', params);
}
export async function create_appointment(params: Record<string, any>) {
  return request.post('/mjstore/create_appointment', params);
}
export async function delete_appointment(params: Record<string, any>) {
  return request.post('/mjstore/delete_appointment', params);
}
export async function query_card_record_time_alert_list(params: Record<string, any>) {
  return request.post('/mjstore/query_card_record_time_alert_list', params);
}
export async function query_customer_remain_info_list(params: Record<string, any>) {
  const res: PageResult = await request.post('/mjstore/query_customer_remain_info_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index+1,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function confirm_card_record_time_alert(params: Record<string, any>) {
  return request.post('/mjstore/confirm_card_record_time_alert', params);
}
export async function get_card_record_time_alert_detail_list(params: Record<string, any>) {
  return request.post('/mjstore/get_card_record_time_alert_detail_list ', params);
}
export async function check_customer_wallet_info(params: Record<string, any>) {
  return request.post('/mjstore/check_customer_wallet_info ', params);
}
export async function update_appointment(params: Record<string, any>) {
  return request.post('/mjstore/update_appointment', params);
}
export async function get_project_set_by_id(params: Record<string, any>) {
  return request.post('/mjstore/get_project_set_by_id', params);
}
export async function start_order_used_record(params: Record<string, any>) {
  return request.post('/mjstore/start_order_used_record', params);
}
export async function end_order_used_record(params: Record<string, any>) {
  return request.post('/mjstore/end_order_used_record', params);
}

export async function query_project_card_can_use_select(params: Record<string, any>) {
  return request.post('/mjstore/query_project_card_can_use_select', params);
}

export async function create_user_type_company_staff(params: Record<string, any>) {
  return request.post('/mjstore/create_user_type_company_staff', params);
}

export async function create_user_type_jms(params: Record<string, any>) {
  return request.post('/mjstore/create_user_type_jms', params);
}

export async function create_user_type_staff(params: Record<string, any>) {
  return request.post('/mjstore/create_user_type_staff', params);
}
export async function create_user_type_shop(params: Record<string, any>) {
  return request.post('/mjstore/create_user_type_shop', params);
}

export async function update_service_detail_image(params: Record<string, any>) {
  return request.post('/mjstore/update_service_detail_image', params);
}

export async function query_order_used_record_staff_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/query_order_used_record_staff_list', params);
}
export async function export_order_used_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/export_order_used_record_list', params);
}
export async function create_order_used_record_by_order(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/create_order_used_record_by_order', params);
}
export async function get_customer_wallet_fl_rate(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/get_customer_wallet_fl_rate', params);
}
export async function update_order_used_record_manual_fee(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/mjstore/update_order_used_record_manual_fee', params);
}
export async function send_receipt(params: Record<string, any>) {
  return request.post('/mjstore/send_receipt', params);
}
export async function delete_person_to_costom_by_custom_id(params: Record<string, any>) {
  return request.post('/mjstore/delete_person_to_costom_by_custom_id', params);
}
export async function query_person_to_costom_list(params: Record<string, any>) {
  return request.post('/mjstore/query_person_to_costom_list', params);
}
export async function query_custom_all_can_send_receipt_by_date(params: Record<string, any>) {
  return request.post('/mjstore/query_custom_all_can_send_receipt_by_date', params);
}
export async function send_receipt_record(params: Record<string, any>) {
  return request.post('/mjstore/send_receipt_record', params);
}
export async function query_receipt_record_list(params: Record<string, any>) {
  return request.post('/mjstore/query_receipt_record_list', params);
}
export async function direct_delete_order_record(params: Record<string, any>) {
  return request.post('/mjstore/direct_delete_order_record', params);
}
export async function direct_delete_card_record(params: Record<string, any>) {
  return request.post('/mjstore/direct_delete_card_record', params);
}
export async function direct_delete_set_record(params: Record<string, any>) {
  return request.post('/mjstore/direct_delete_set_record', params);
}
export async function trans_card_record(params: Record<string, any>) {
  return request.post('/mjstore/trans_card_record', params);
}
export async function query_kzk_card_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  const res: PageResult = await request.post('/mjstore/query_kzk_card_record_list', params);
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: item._kzd_code + item._order_code + index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_card_record_extend_record_list(params: Record<string, any>) {
  return request.post('/mjstore/query_card_record_extend_record_list', params);
}
export async function extend_card_record_end_date(params: Record<string, any>) {
  return request.post('/mjstore/extend_card_record_end_date', params);
}
export async function create_customer_type(params: Record<string, any>) {
  return request.post('/mjstore/create_customer_type', params);
}
export async function update_customer_type(params: Record<string, any>) {
  return request.post('/mjstore/update_customer_type', params);
}
export async function query_customer_type_list(params: Record<string, any>) {
  return request.post('/mjstore/query_customer_type_list', params);
}
export async function delete_customer_type(params: Record<string, any>) {
  return request.post('/mjstore/delete_customer_type_list', params);
}
export async function recover_customer_type(params: Record<string, any>) {
  return request.post('/mjstore/recover_customer_type', params);
}

export async function create_customer_activation(params: Record<string, any>) {
  return request.post('/mjstore/create_customer_activation', params);
}
export async function update_customer_activation(params: Record<string, any>) {
  return request.post('/mjstore/update_customer_activation', params);
}
export async function query_customer_activation_list(params: Record<string, any>) {
  return request.post('/mjstore/query_customer_activation_list', params);
}
export async function delete_customer_activation(params: Record<string, any>) {
  return request.post('/mjstore/delete_customer_activation', params);
}
export async function recover_customer_activation(params: Record<string, any>) {
  return request.post('/mjstore/recover_customer_activation', params);
}
export async function query_customer_activation_active_list_by_date_range(
  params: Record<string, any>,
) {
  const res: PageResult = await request.post(
    '/mjstore/query_customer_activation_active_list_by_date_range',
    params,
  );
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_customer_activation_list_by_date(params: Record<string, any>) {
  const res: PageResult = await request.post(
    '/mjstore/query_customer_activation_list_by_date',
    params,
  );
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_customer_activation_change_record_list(params: Record<string, any>) {
  return request.post('/mjstore/query_customer_activation_change_record_list', params);
}
export async function query_customer_list_and_change_rate_with_customer_type(
  params: Record<string, any>,
) {
  const res: PageResult = await request.post(
    '/mjstore/query_customer_list_and_change_rate_with_customer_type',
    params,
  );
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_customer_list_with_customer_type(params: Record<string, any>) {
  const res: PageResult = await request.post(
    '/mjstore/query_customer_list_with_customer_type',
    params,
  );
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      ...item,
    });
  });
  res.data = list;
  return res;
}
export async function query_customer_activation_event_list(params: Record<string, any>) {
  const res: PageResult = await request.post(
    '/mjstore/query_customer_activation_event_list',
    params,
  );
  const list: any = [];
  res.data.forEach((item: any, index: number) => {
    list.push({
      _index: index,
      _record__customer__code: item.record.customer__code,
      _record__customer__name: item.record.customer__name,
      _record__customer__shop__name: item.record.customer__shop__name,
      _record__customer__adviser__name: item.record.customer__adviser__name,
      ...item,
    });
  });
  res.data = list;
  return res;
}

export async function create_staff_title(params: Record<string, any>) {
  return request.post('/mjstore/create_staff_title', params);
}

export async function update_staff_title(params: Record<string, any>) {
  return request.post('/mjstore/update_staff_title', params);
}

export async function delete_staff_title(params: Record<string, any>) {
  return request.post('/mjstore/delete_staff_title', params);
}

export async function recover_staff_title(params: Record<string, any>) {
  return request.post('/mjstore/recover_staff_title', params);
}

export async function query_staff_title_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/mjstore/query_staff_title_list', params);
}
